import { render } from "./Item4.vue?vue&type=template&id=7650f08e&ts=true"
import script from "./Item4.vue?vue&type=script&lang=ts"
export * from "./Item4.vue?vue&type=script&lang=ts"

import exportComponent from "/Users/javiermartin/OneDrive_Sigeen/Sistena/Server_Mio/sistena-admin-gui-main_rev1/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__